import { componentWithName } from 'airbnb-prop-types';
import { STRIP_HOC_NAMES } from '../constants';

const propType = componentWithName(/(Icon[A-Z]|DirectionalIcon|ExpandableIcon)/, {
  stripHOCs: STRIP_HOC_NAMES,
});

export default propType;
